import ChangeLogItem from './change-log-item';
import formatDate from '../../../helpers/format-date';
import { TransactionChangeLogsTypes } from './types';

import styles from '../transaction.module.css';

export default function TransactionChangeLog({
  changeLogs,
  pspPartners,
}: TransactionChangeLogsTypes) {
  let content;

  if (changeLogs && (changeLogs?.length) > 0) {
    content = changeLogs?.map(
      (item) =>
        Object.keys(item.diff.prev).length > 0 && (
          <div key={item.id}>
            <div className={styles.changeLogItemTitle}>
              <div className={styles.changeLogItemTitleLeft}>
                {item.employeeName || 'Auto'}
              </div>
              <div className={styles.changeLogItemTitleRight}>
                {formatDate(item.createdAt, true)}
              </div>
            </div>
            <ChangeLogItem
              changeLog={item.diff}
              key={item.id}
              pspPartners={pspPartners}
            />
          </div>
        ),
    );
  } else {
    content = <div className={styles.emptyChangeLogs}>No change logs yet</div>;
  }

  return (
    <div className={styles.changeLogsWrapper}>
      <div className={styles.changeLogsTitle}>Change Logs</div>
      {content}
    </div>
  );
}
